import React from 'react'
import PropTypes from 'prop-types'
import {ToursPageTemplate} from '../../templates/tours-page'

const ToursPagePreview = ({ entry, getAsset, widgetFor }) => {
  return (
    <ToursPageTemplate
      image={getAsset(entry.getIn(['data', 'image']))}
      title={entry.getIn(['data', 'title'])}
      subtitle={entry.getIn(['data', 'subtitle'])}
      content={widgetFor('body')}
    />
  )
}

ToursPagePreview.propTypes = {
  entry: PropTypes.shape({
    getIn: PropTypes.func,
  }),
  getAsset: PropTypes.func,
  widgetFor: PropTypes.func,
}

export default ToursPagePreview
